<template>
  <div class="ma-0 pa-0" style="height: 90vh; overflow: hidden">
    <Navigation />
    <v-row class="d-flex justify-end pa-0 ma-0">
      <v-col style="max-width: calc(100% - 56px)">
        <div class="pb-0 mb-0">
          <ToolbarTitles :title="title" class="d-flex flex-wrap mx-auto" />
        </div>
        <div
          class="d-flex flex-wrap justify-space-between my-auto pb-0 mx-auto"
        >
          <data-employed />
          <nav-buttons :title="title" />
        </div>
        <OrganizationModel
          :headers="allHeaders"
          :items="getModelEmployed"
          :deleteTitle="deleteTitle"
          :nameAction="title"
          :addTitle="addModel"
          :saveConfigColums="saveConfigColumns"
          :asegurable="'accion:modelosempleado'"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Navigation from "./Navigation.vue";
import ToolbarTitles from "../../../Complement/ToolbarTitles.vue";
import OrganizationModel from "../../commons/OrganizationModel.vue";
import NavButtons from "../../commons/NavButtons.vue";
import DataEmployed from "../../commons/DataEmployed.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    DataEmployed,
    Navigation,
    ToolbarTitles,
    OrganizationModel,
    NavButtons,
  },
  data() {
    return {
      title: "Modelos",
      deleteTitle: "¿Desea eliminar el Modelo?",
      addModel: " Modelo",
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Fecha Desde",
          value: "from",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Fecha Hasta",
          value: "to",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
    };
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.title;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    this.$store.dispatch("changeSettlementModel/getModelEmployed");
  },
  computed: {
    getModelEmployed() {
      const items =
        this.$store.state.changeSettlementModel.modelEmployed.item || [];

      const parseDate = (str) => {
        if (!str || str.trim() === "") return 0;
        const [day, month, year] = str.split("-");
        return new Date(`${year}-${month}-${day}`).getTime();
      };

      return [...items].sort((a, b) => {
        return parseDate(b.from) - parseDate(a.from);
      });
    },
    allHeaders() {
      return configTable.state.colums;
    },
  },
  methods: {
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.title,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {});
    },
  },
};
</script>
